
import NoticeModularService from '../notice-modular-service';
import FormulaAssetsInfo from '@/components/formula-assets-info/formula-assets-info.vue';
export default {
  components: {
    FormulaAssetsInfo
  },
  data () {
    return {
      id: '', // 标的id
      projectInfo: {},
      notice_time: '', // 公告时间
      type: 0, // 判断是转让还是采购
      transaction: {}, // 流转详情
      bidInfo: { detail: [] },
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      citytitle: ''
    };
  },
  computed: {
    startTimeText () {
      const projectType = this.transaction.projectType;
      if (projectType === '6') {
        return '出租期限';
      }
      return '发包期限';
    },
    sumPlant () {
      let num = 0;
      this.bidInfo.detail.forEach(item => {
        // const obj = JSON.stringify(item.assetsInfo);
        if (item.forestList) {
          item.forestList.forEach(forestItem => {
            num += Number(forestItem.treeNumber);
          });
        }
      });
      return num;
    },
    projectCode () {
      if (this.transaction && this.transaction.projectType && this.transaction.projectSubType) {
        return `${this.transaction.projectType}-${this.transaction.projectSubType}`;
      }
    }
  },
  created () {
    this.id = this.$route.query.id;
    this.notice_time = this.$route.query.time;
    this.type = this.$route.query.type;
  },
  mounted () {
    if (this.$route.query.type === '1') {
      // 流转
      if (this.id === '999999999') {
        this.simulatedData();
      } else {
        this.getAuctionResults();
      }
    } else {
      // 集采
      this.getNoticeDetail();
    }
  },
  methods: {
    getNoticeDetail () {
      NoticeModularService.getBatchdetails(this.id).then(res => {
        if (res && res.code === '0') {
          this.transaction = res.data;
          this.tableData = res.data.excelList;
        }
      });
    },
    // TODO 临时 模拟数据
    simulatedData () {
      this.transaction = {
        'sumPrice': '630000',
        'tradeTypeValue': '协议交易',
        'publicityEndPeriod': '2021年05月21日',
        'projectType': '4',
        'sumArea': '105.00',
        'signDate': '2021年05月20日',
        'projectCode': '0322106-210843J',
        'managerCompanyName': '广西田东农村产权交易服务中心永吉县黄榆乡工作站',
        'startTime': '2021年05月19日',
        'purchaseUserName': '张凝',
        'purchaseCompanyName': '永吉县黄榆乡头道川村村民委员会',
        'village': '头道川村',
        'tradeType': '协议交易',
        'projectAssets': [
          {
            'assetsInfo': '{"area":"105.00","toSouth":"r","attachment":"r","price":0,"toNorth":"r","toEast":"r","massifName":"水库沟里荒地","type":"3","toWest":"r","certificateNo":"","originalContractor":"","announceRemark":""}',
            'transfereeName': '吉林善诚农业有限公司',
            'currentPrice': null,
            'remark': null
          }
        ],
        'address': '永吉县黄榆乡头道川村2组',
        'purchaseMobile': '13944600008',
        'managerMobile': '13044396535',
        'projectSubType': '1',
        'groupName': '广西田东农村产权交易服务中心梨树县蔡家镇工作站',
        'managerAddress': '永吉县黄榆乡',
        'publicityStartPeriod': '2021年05月19日',
        'endTime': '2050年05月19日',
        'purchaseAddress': '永吉县黄榆乡头道川村八社',
        'projectName': ' 吉林市永吉县黄榆乡头道川村二社荒地',
        'managerUserName': '李丹婷',
        'sumPriceUpper': '陆万叁仟万元',
        'township': '永吉县黄榆乡'
      };
      this.bidInfo = {
        detail: this.transaction.projectAssets
      };
    },
    getAuctionResults () {
      NoticeModularService.getAuctionResults(this.id).then(res => {
        if (res && res.code === '0') {
          this.transaction = res.data;
          let arr = null;
          if (typeof res.data.projectAssets === 'string') {
            arr = JSON.parse(res.data.projectAssets);
          } else {
            arr = res.data.projectAssets;
          }
          // console.log(typeof res.data.projectAssets === 'string');
          console.log(arr);
          this.bidInfo = {
            detail: arr
          };
        }
      });
    }
  }
};
